import { DocAssociation } from './SharedEnums';

// associations.ts
export class SaturnAssociation {
	type: DocAssociation;
	id: string;

	constructor(partial?: Partial<SaturnAssociation>) {
		this.type = partial?.type ?? null;
		this.id = partial?.id ?? null;
	}
}
